import axios from 'axios'

const options = {
  baseURL: process.env.EMBEDLY_API_BASE,
  headers: {
    Accept: 'application/json'
  }
}

const api = axios.create(options)

// Adds API token to requests
api.interceptors.request.use(config => {
  config.params.key = process.env.EMBEDLY_API_KEY
  return config
})

export default api



// WEBPACK FOOTER //
// ./src/api/embedly.js